export default __webpack_public_path__ + "static/media/menu-profile-icon.4626b628.svg";